import {updateAdCredits} from 'app/helpers/adStepper';
import Video from 'app/components/tv/models/video';

export const trackVideoProgress = (video: Video, playedTime: TimeRanges) => {
  updateAdCredits(video, playedTime);
};
